/**
 * Per-tenant theme application for Card Match. Sets the same --sg-* CSS vars
 * the WhatIs / Survey Says / Anagram modules use so streamers' tuned palette
 * carries across games.
 */
import type { ThemePalette } from '@sg/shared';

function buildDefaultTheme(): ThemePalette {
  const t: Partial<ThemePalette> = {};
  // Purple/cyan/magenta brand palette per the spec.
  t.primary = '#A855F7'; // purple
  t.secondary = '#06B6D4'; // cyan
  t.accent = '#EC4899'; // magenta
  t.background = '#0A0E27';
  t.text_on_primary = '#FFFFFF';
  t.text_on_secondary = '#0A0E27';
  t.tile_bg = '#1F1B4B';
  t.celebration = '#22C55E';
  return t as ThemePalette;
}

/** Card Match default palette — purple/cyan/magenta brand. */
export const DEFAULT_THEME: ThemePalette = buildDefaultTheme();

export type ThemeVarKey =
  | 'primary' | 'secondary' | 'accent' | 'background'
  | 'text_on_primary' | 'text_on_secondary' | 'tile_bg' | 'celebration';

const THEME_VAR_MAP = new Map<ThemeVarKey, string>([
  ['primary', '--sg-primary'],
  ['secondary', '--sg-secondary'],
  ['accent', '--sg-accent'],
  ['background', '--sg-bg'],
  ['text_on_primary', '--sg-text-on-primary'],
  ['text_on_secondary', '--sg-text-on-secondary'],
  ['tile_bg', '--sg-tile-bg'],
  ['celebration', '--sg-celebration'],
]);

export function applyTheme(theme: ThemePalette): void {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  root.style.setProperty(THEME_VAR_MAP.get('primary')!, theme.primary);
  root.style.setProperty(THEME_VAR_MAP.get('secondary')!, theme.secondary);
  root.style.setProperty(THEME_VAR_MAP.get('accent')!, theme.accent);
  root.style.setProperty(THEME_VAR_MAP.get('background')!, theme.background);
  root.style.setProperty(THEME_VAR_MAP.get('text_on_primary')!, theme.text_on_primary);
  root.style.setProperty(THEME_VAR_MAP.get('text_on_secondary')!, theme.text_on_secondary);
  root.style.setProperty(THEME_VAR_MAP.get('tile_bg')!, theme.tile_bg);
  root.style.setProperty(THEME_VAR_MAP.get('celebration')!, theme.celebration);
}
